import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseOptionAPI } from '@core/_base/crud/models/_base.option-api';
import { TypesUtilsService, ResponseBody } from '@core/_base/crud';
import { environment } from '@env/environment';

const API_URL: string = environment.api.host + '/report/fuel-change';
const API_URL_DETAIL: string = environment.api.host + '/report/temperature-detailed';
const API_URL_SUMMARY: string = environment.api.host + '/report/temperature-summary';
const API_URL_DETAIL_EXCEL: string = environment.api.host + '/report/temperature-detailed-excel';
const API_URL_CHART: string = environment.api.host + '/report/temperature-chart';
@Injectable({
	providedIn: 'root',
})
export class ReportTemperatureService {
	constructor(private http: HttpClient, private utils: TypesUtilsService) {}
	list(params: any): Observable<ResponseBody> {
		return this.http.get<ResponseBody>(API_URL, { params: params });
	}

	detail(params: any, option?: BaseOptionAPI): Observable<ResponseBody> {
		return this.http.get<ResponseBody>(API_URL_DETAIL, { params: params });
	}

	chart(params: any, option?: BaseOptionAPI): Observable<ResponseBody> {
		return this.http.get<ResponseBody>(API_URL_CHART, { params: params });
	}

	summary(params: any, option?: BaseOptionAPI): Observable<ResponseBody> {
		return this.http.get<ResponseBody>(API_URL_SUMMARY, { params: params });
	}

	detailExcel(params: any, option?: BaseOptionAPI): Observable<ResponseBody> {
		return this.http.get<ResponseBody>(API_URL_DETAIL_EXCEL, { params: params });
	}
}
